import { useIntl } from 'react-intl';

import EmptyIcon from '@/assets/icons/empty-campaigns.svg';
import { EmptyState } from '@/components/ui/empty-state';

export function NoOpenings() {
  const intl = useIntl();

  return (
    <EmptyState
      icon={EmptyIcon}
      header={intl.formatMessage({
        defaultMessage: 'No openings to show',
      })}
      description={intl.formatMessage({
        defaultMessage: 'There are no openings to show at the moment.',
      })}
    />
  );
}
